package com.evoapps.evoshift.ui.hiring

import androidx.compose.foundation.background
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Block
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Event
import androidx.compose.material.icons.filled.EventBusy
import androidx.compose.material.icons.filled.MarkEmailUnread
import androidx.compose.material.icons.filled.PersonAdd
import androidx.compose.material.icons.filled.PersonSearch
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.StarBorder
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.domain.model.ApplicantStatus
import com.evoapps.evoshift.domain.model.ApplicationFilter
import com.evoapps.evoshift.domain.model.Interview
import com.evoapps.evoshift.domain.model.InterviewRequest
import com.evoapps.evoshift.domain.model.InvalidInterviewException
import com.evoapps.evoshift.domain.model.JobApplication
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.interviewProblemText
import com.evoapps.evoshift.viewmodels.ApplicantsUiState
import com.evoapps.evoshift.viewmodels.ApplicantsViewModel
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSectionLabel
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoSwitchRow
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.LoadingOverlay
import com.evoapps.evoshift.widgets.MissingYear
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.applicant_availability
import evoshift.composeapp.generated.resources.applicant_call
import evoshift.composeapp.generated.resources.applicant_consent_future
import evoshift.composeapp.generated.resources.applicant_cv
import evoshift.composeapp.generated.resources.applicant_delete
import evoshift.composeapp.generated.resources.applicant_delete_confirm_text
import evoshift.composeapp.generated.resources.applicant_delete_confirm_title
import evoshift.composeapp.generated.resources.applicant_hire
import evoshift.composeapp.generated.resources.applicant_manager_note
import evoshift.composeapp.generated.resources.applicant_manager_note_hint
import evoshift.composeapp.generated.resources.applicant_mark_unread
import evoshift.composeapp.generated.resources.applicant_note
import evoshift.composeapp.generated.resources.applicant_reject
import evoshift.composeapp.generated.resources.applicant_reject_already_sent
import evoshift.composeapp.generated.resources.applicant_reject_no_email
import evoshift.composeapp.generated.resources.applicant_reject_send_mail
import evoshift.composeapp.generated.resources.applicant_reject_text
import evoshift.composeapp.generated.resources.applicant_reject_title
import evoshift.composeapp.generated.resources.applicant_sent
import evoshift.composeapp.generated.resources.applicant_stage
import evoshift.composeapp.generated.resources.applicant_star
import evoshift.composeapp.generated.resources.applicant_status_contacted
import evoshift.composeapp.generated.resources.applicant_status_hired
import evoshift.composeapp.generated.resources.applicant_status_new
import evoshift.composeapp.generated.resources.applicant_status_rejected
import evoshift.composeapp.generated.resources.applicant_status_trial
import evoshift.composeapp.generated.resources.applicant_unstar
import evoshift.composeapp.generated.resources.applicant_write
import evoshift.composeapp.generated.resources.applicants_empty
import evoshift.composeapp.generated.resources.applicants_filter_all
import evoshift.composeapp.generated.resources.applicants_filter_rejected
import evoshift.composeapp.generated.resources.applicants_filter_starred
import evoshift.composeapp.generated.resources.applicants_filter_unread
import evoshift.composeapp.generated.resources.applicants_retention
import evoshift.composeapp.generated.resources.applicants_title
import evoshift.composeapp.generated.resources.hiring_applicants
import evoshift.composeapp.generated.resources.interview_cancel
import evoshift.composeapp.generated.resources.interview_cancel_confirm_text
import evoshift.composeapp.generated.resources.interview_cancel_confirm_title
import evoshift.composeapp.generated.resources.interview_candidate_removed
import evoshift.composeapp.generated.resources.interview_date
import evoshift.composeapp.generated.resources.interview_dialog_title
import evoshift.composeapp.generated.resources.interview_length
import evoshift.composeapp.generated.resources.interview_minutes
import evoshift.composeapp.generated.resources.interview_move
import evoshift.composeapp.generated.resources.interview_no_email
import evoshift.composeapp.generated.resources.interview_note
import evoshift.composeapp.generated.resources.interview_online_link
import evoshift.composeapp.generated.resources.interview_paid
import evoshift.composeapp.generated.resources.interview_paid_hint
import evoshift.composeapp.generated.resources.interview_paid_label
import evoshift.composeapp.generated.resources.interview_participants
import evoshift.composeapp.generated.resources.interview_place
import evoshift.composeapp.generated.resources.interview_place_hint
import evoshift.composeapp.generated.resources.interview_reschedule_title
import evoshift.composeapp.generated.resources.interview_save
import evoshift.composeapp.generated.resources.interview_save_move
import evoshift.composeapp.generated.resources.interview_schedule
import evoshift.composeapp.generated.resources.interview_send
import evoshift.composeapp.generated.resources.interview_status_cancelled
import evoshift.composeapp.generated.resources.interview_time
import evoshift.composeapp.generated.resources.interview_time_hint
import evoshift.composeapp.generated.resources.interview_unpaid_hint
import evoshift.composeapp.generated.resources.interview_unpaid_label
import evoshift.composeapp.generated.resources.interview_when
import evoshift.composeapp.generated.resources.interviews_section
import evoshift.composeapp.generated.resources.save
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

fun ApplicantStatus.label(): StringResource = when (this) {
    ApplicantStatus.NEW -> Res.string.applicant_status_new
    ApplicantStatus.CONTACTED -> Res.string.applicant_status_contacted
    ApplicantStatus.TRIAL -> Res.string.applicant_status_trial
    ApplicantStatus.HIRED -> Res.string.applicant_status_hired
    ApplicantStatus.REJECTED -> Res.string.applicant_status_rejected
}

/** SH-210: the list's filters. */
fun ApplicationFilter.label(): StringResource = when (this) {
    ApplicationFilter.ALL -> Res.string.applicants_filter_all
    ApplicationFilter.UNREAD -> Res.string.applicants_filter_unread
    ApplicationFilter.STARRED -> Res.string.applicants_filter_starred
    ApplicationFilter.REJECTED -> Res.string.applicants_filter_rejected
}

/** Test tags of the applicants' screen and its dialogs (SH-210). */
object ApplicantsTags {
    fun filter(filter: ApplicationFilter) = "applicants_filter_${filter.name}"
    fun card(id: String) = "applicant_card_$id"
    fun star(id: String) = "applicant_star_$id"
    fun unread(id: String) = "applicant_unread_$id"
    const val DETAIL_STAR = "applicant_detail_star"
    const val MARK_UNREAD = "applicant_mark_unread"
    const val REJECT = "applicant_reject"
    const val REJECT_SEND_MAIL = "applicant_reject_send_mail"
    const val SCHEDULE = "applicant_schedule_interview"
    fun interview(id: String) = "applicant_interview_$id"
    fun moveInterview(id: String) = "applicant_interview_move_$id"
    fun cancelInterview(id: String) = "applicant_interview_cancel_$id"
    const val INTERVIEW_DATE = "interview_date"
    const val INTERVIEW_TIME = "interview_time"
    fun length(minutes: Int) = "interview_length_$minutes"
    const val INTERVIEW_PLACE = "interview_place"
    const val INTERVIEW_LINK = "interview_link"
    const val INTERVIEW_NOTE = "interview_note"
    fun participant(uid: String) = "interview_participant_$uid"
    const val INTERVIEW_PAID = "interview_paid"
    const val INTERVIEW_SEND = "interview_send"
}

/** The interview lengths offered, in minutes. */
val INTERVIEW_LENGTHS = listOf(15, 30, 45, 60, 90)

/**
 * SH-125: a job post's applicants: a card per applicant, and the applicant's dialog with their
 * contact (call, e-mail), availability, note, consent and CV, the stage and the manager's note,
 * "Hire and invite" ([onHire]: the employee form filled in) and deleting them. The retention rule
 * is said under the list.
 *
 * SH-210: filters All / Unread / Favourites / Rejected with counts for the viewer; an unread dot
 * and a star on each card; opening one marks it read, the dialog marks it unread again or starred;
 * rejecting (optionally with the post's e-mail); the applicant's interviews with scheduling,
 * moving and cancelling.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun ApplicantsScreen(
    viewModel: ApplicantsViewModel,
    onNavigateBack: () -> Unit,
    onHire: (workplaceId: String, postId: String, applicationId: String) -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val uriHandler = LocalUriHandler.current
    val messageText = state.message?.asString()
    LaunchedEffect(messageText) {
        messageText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }
    LaunchedEffect(state.openUrl) {
        state.openUrl?.let {
            runCatching { uriHandler.openUri(it) }
            viewModel.urlOpened()
        }
    }

    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = state.post?.title?.let { stringResource(Res.string.applicants_title, it) } ?: stringResource(Res.string.hiring_applicants),
                onBack = onNavigateBack
            )
        }
    ) { padding ->
        Box(Modifier.fillMaxSize().contentWidth(LocalWindowWidthClass.current.wideContentMaxWidth).padding(padding)) {
            AdaptiveCardGrid(
                modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp),
                spacing = 12.dp,
                contentPadding = PaddingValues(vertical = 12.dp)
            ) {
                item(span = { GridItemSpan(maxLineSpan) }) {
                    val colors = FilterChipDefaults.filterChipColors(
                        selectedContainerColor = DeepNavy, selectedLabelColor = Color.White, labelColor = DeepNavy
                    )
                    Row(Modifier.horizontalScroll(rememberScrollState()), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        ApplicationFilter.entries.forEach { filter ->
                            FilterChip(
                                selected = state.filter == filter,
                                onClick = { viewModel.filter(filter) },
                                label = { Text("${stringResource(filter.label())} (${state.count(filter)})") },
                                colors = colors,
                                modifier = Modifier.handCursor().testTag(ApplicantsTags.filter(filter))
                            )
                        }
                    }
                }
                if (state.shown.isEmpty() && !state.isLoading) {
                    item(span = { GridItemSpan(maxLineSpan) }) {
                        Text(stringResource(Res.string.applicants_empty), color = DeepNavy.copy(alpha = 0.6f))
                    }
                }
                items(state.shown, key = { it.id }) { application ->
                    Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                        ApplicantCard(
                            application = application,
                            unread = !application.isReadBy(state.viewerId),
                            starred = application.isStarredBy(state.viewerId),
                            onOpen = { viewModel.open(application) },
                            onStar = { viewModel.toggleStar(application) }
                        )
                    }
                }
                item(span = { GridItemSpan(maxLineSpan) }) {
                    Text(
                        stringResource(Res.string.applicants_retention),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.6f),
                        modifier = Modifier.padding(top = 8.dp, bottom = 24.dp)
                    )
                }
            }
            LoadingOverlay(isLoading = state.isLoading)
        }
    }

    val open = state.open ?: return
    // One dialog at a time: the interview dialog replaces the applicant's.
    val draft = state.interviewDraft
    if (draft != null && draft.applicationId == open.id) {
        InterviewDialog(
            application = open,
            interview = draft.interview,
            team = state.team,
            problem = state.interviewProblem,
            saving = state.isSaving,
            onDismiss = viewModel::dismissInterview,
            onSave = viewModel::saveInterview
        )
        return
    }
    ApplicantDialog(
        state = state,
        application = open,
        onDismiss = viewModel::close,
        onSave = { status, note ->
            viewModel.update(open, status, note)
            viewModel.close()
        },
        onStar = { viewModel.toggleStar(open) },
        onMarkUnread = { viewModel.markUnread(open) },
        onCall = { phone -> runCatching { uriHandler.openUri("tel:${phone.filter { it.isDigit() || it == '+' }}") } },
        onWrite = { email -> runCatching { uriHandler.openUri("mailto:$email") } },
        onCv = { viewModel.openCv(open) },
        onHire = {
            viewModel.close()
            state.post?.let { onHire(it.workplaceId, it.id, open.id) }
        },
        onReject = { sendMail, note -> viewModel.reject(open, sendMail, note) },
        onSchedule = { interview -> viewModel.startInterview(open, interview) },
        onCancelInterview = { interview -> viewModel.cancel(interview) },
        onDelete = { viewModel.delete(open) }
    )
}

@Composable
private fun ApplicantCard(application: JobApplication, unread: Boolean, starred: Boolean, onOpen: () -> Unit, onStar: () -> Unit) {
    RegularCard(Modifier.fillMaxWidth().testTag(ApplicantsTags.card(application.id)), onClick = onOpen) {
        Column(Modifier.padding(start = 16.dp, end = 4.dp, top = 8.dp, bottom = 16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                if (unread) {
                    // SH-210: not opened by the viewer yet.
                    val description = stringResource(Res.string.applicants_filter_unread)
                    Box(
                        Modifier.size(10.dp).clip(CircleShape).background(DarkGold).testTag(ApplicantsTags.unread(application.id))
                            .semantics { contentDescription = description }
                    )
                }
                Text(
                    application.name, style = MaterialTheme.typography.titleMedium, color = DeepNavy, modifier = Modifier.weight(1f),
                    fontWeight = if (unread) FontWeight.ExtraBold else FontWeight.Bold
                )
                Text(stringResource(application.status.label()), style = MaterialTheme.typography.labelLarge, color = DarkGold, fontWeight = FontWeight.Bold)
                IconButtonWithTooltip(onClick = onStar, modifier = Modifier.handCursor().testTag(ApplicantsTags.star(application.id)), tooltip = stringResource(if (starred) Res.string.applicant_unstar else Res.string.applicant_star)) {
                    Icon(
                        if (starred) Icons.Default.Star else Icons.Default.StarBorder,
                        contentDescription = stringResource(if (starred) Res.string.applicant_unstar else Res.string.applicant_star),
                        tint = if (starred) DarkGold else DeepNavy.copy(alpha = 0.7f)
                    )
                }
            }
            Text(stringResource(Res.string.applicant_sent, application.createdAt.take(10)), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            application.availability?.let { Text(it, style = MaterialTheme.typography.bodyMedium, color = DeepNavy, maxLines = 2) }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ApplicantDialog(
    state: ApplicantsUiState,
    application: JobApplication,
    onDismiss: () -> Unit,
    onSave: (ApplicantStatus, String?) -> Unit,
    onStar: () -> Unit,
    onMarkUnread: () -> Unit,
    onCall: (String) -> Unit,
    onWrite: (String) -> Unit,
    onCv: () -> Unit,
    onHire: () -> Unit,
    onReject: (sendMail: Boolean, note: String?) -> Unit,
    onSchedule: (Interview?) -> Unit,
    onCancelInterview: (Interview) -> Unit,
    onDelete: () -> Unit
) {
    val canEdit = state.canEdit
    var status by remember(application.id) { mutableStateOf(application.status) }
    var note by remember(application.id) { mutableStateOf(application.managerNote.orEmpty()) }
    var confirmDelete by remember(application.id) { mutableStateOf(false) }
    var confirmReject by remember(application.id) { mutableStateOf(false) }
    var cancelling by remember(application.id) { mutableStateOf<Interview?>(null) }
    val starred = application.isStarredBy(state.viewerId)
    // The confirmations replace the applicant's dialog (one dialog at a time).
    if (confirmDelete) {
        EvoConfirmDialog(
            title = stringResource(Res.string.applicant_delete_confirm_title),
            text = stringResource(Res.string.applicant_delete_confirm_text),
            confirmLabel = stringResource(Res.string.applicant_delete),
            onConfirm = {
                confirmDelete = false
                onDelete()
            },
            onDismiss = { confirmDelete = false },
            destructive = true,
            icon = Icons.Default.Delete
        )
        return
    }
    if (confirmReject) {
        RejectDialog(
            application = application,
            offerMail = state.post?.rejectionMail?.enabled == true,
            onConfirm = { sendMail ->
                confirmReject = false
                onReject(sendMail, note)
            },
            onDismiss = { confirmReject = false }
        )
        return
    }
    cancelling?.let { interview ->
        EvoConfirmDialog(
            title = stringResource(Res.string.interview_cancel_confirm_title),
            text = stringResource(Res.string.interview_cancel_confirm_text),
            confirmLabel = stringResource(Res.string.interview_cancel),
            onConfirm = {
                cancelling = null
                onCancelInterview(interview)
            },
            onDismiss = { cancelling = null },
            destructive = true,
            icon = Icons.Default.EventBusy
        )
        return
    }
    EvoDialog(
        title = application.name,
        subtitle = stringResource(Res.string.applicant_sent, application.createdAt.take(10)),
        icon = Icons.Default.PersonSearch,
        onDismiss = onDismiss,
        confirm = if (canEdit) DialogAction(stringResource(Res.string.save), { onSave(status, note) }) else null
    ) {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Box(Modifier.testTag(ApplicantsTags.DETAIL_STAR)) {
                EvoSecondaryButton(
                    DialogAction(
                        stringResource(if (starred) Res.string.applicant_unstar else Res.string.applicant_star), onStar,
                        icon = if (starred) Icons.Default.Star else Icons.Default.StarBorder
                    ),
                    quiet = true
                )
            }
            Box(Modifier.testTag(ApplicantsTags.MARK_UNREAD)) {
                EvoSecondaryButton(
                    DialogAction(stringResource(Res.string.applicant_mark_unread), onMarkUnread, icon = Icons.Default.MarkEmailUnread),
                    quiet = true
                )
            }
        }
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            application.phone?.let { phone ->
                EvoSecondaryButton(DialogAction(stringResource(Res.string.applicant_call), { onCall(phone) }, icon = Icons.Default.Phone))
            }
            application.email?.let { email ->
                EvoSecondaryButton(DialogAction(stringResource(Res.string.applicant_write), { onWrite(email) }, icon = Icons.Default.Email))
            }
            application.cv?.let { cv ->
                EvoSecondaryButton(DialogAction(stringResource(Res.string.applicant_cv, cv.fileName), onCv, icon = Icons.Default.Description))
            }
        }
        listOfNotNull(application.phone, application.email).forEach { Text(it, color = Color.White) }
        application.availability?.let {
            DialogSectionLabel(stringResource(Res.string.applicant_availability))
            Text(it, color = Color.White)
        }
        application.note?.let {
            DialogSectionLabel(stringResource(Res.string.applicant_note))
            Text(it, color = Color.White)
        }
        if (application.futureRecruitment) {
            Text(stringResource(Res.string.applicant_consent_future), color = Color.White.copy(alpha = 0.8f), style = MaterialTheme.typography.bodySmall)
        }
        DialogSectionLabel(stringResource(Res.string.applicant_stage))
        val colors = FilterChipDefaults.filterChipColors(
            selectedContainerColor = MaterialTheme.colorScheme.secondary, selectedLabelColor = DeepNavy, labelColor = Color.White
        )
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            ApplicantStatus.entries.forEach { option ->
                FilterChip(
                    selected = status == option, onClick = { status = option }, enabled = canEdit,
                    label = { Text(stringResource(option.label())) }, colors = colors, modifier = Modifier.handCursor()
                )
            }
        }
        EvoTextField(
            value = note,
            onValueChange = { note = it.take(JobApplication.MAX_MANAGER_NOTE) },
            label = stringResource(Res.string.applicant_manager_note),
            supportingText = stringResource(Res.string.applicant_manager_note_hint),
            singleLine = false, minLines = 2, enabled = canEdit
        )
        // SH-210: the applicant's interviews.
        if (state.interviews.isNotEmpty() || canEdit) DialogSectionLabel(stringResource(Res.string.interviews_section))
        state.interviews.forEach { interview ->
            InterviewRow(
                interview = interview, nameOf = state::nameOf, canEdit = canEdit,
                onMove = { onSchedule(interview) }, onCancel = { cancelling = interview }
            )
        }
        if (canEdit) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(Modifier.testTag(ApplicantsTags.SCHEDULE)) {
                    EvoSecondaryButton(DialogAction(stringResource(Res.string.interview_schedule), { onSchedule(null) }, icon = Icons.Default.Event))
                }
                if (application.status != ApplicantStatus.HIRED) {
                    EvoSecondaryButton(DialogAction(stringResource(Res.string.applicant_hire), onHire, icon = Icons.Default.PersonAdd))
                }
                if (application.status != ApplicantStatus.REJECTED) {
                    Box(Modifier.testTag(ApplicantsTags.REJECT)) {
                        EvoSecondaryButton(
                            DialogAction(stringResource(Res.string.applicant_reject), { confirmReject = true }, destructive = true, icon = Icons.Default.Block)
                        )
                    }
                }
            }
        }
        if (state.canDelete) {
            EvoSecondaryButton(
                DialogAction(stringResource(Res.string.applicant_delete), { confirmDelete = true }, destructive = true, icon = Icons.Default.Delete),
                quiet = true
            )
        }
    }
}

/** One interview of the applicant: when, where, who, paid or not; move and cancel. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun InterviewRow(interview: Interview, nameOf: (String) -> String, canEdit: Boolean, onMove: () -> Unit, onCancel: () -> Unit) {
    Column(
        Modifier.fillMaxWidth().clip(RoundedCornerShape(12.dp)).background(Color.White.copy(alpha = 0.08f)).padding(12.dp)
            .testTag(ApplicantsTags.interview(interview.id)),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Text(
            stringResource(Res.string.interview_when, interview.date, interview.startTime, interview.endTime),
            color = Color.White, fontWeight = FontWeight.Bold
        )
        listOfNotNull(interview.location, interview.onlineUrl).forEach { Text(it, color = Color.White) }
        if (interview.participantIds.isNotEmpty()) {
            Text(interview.participantIds.joinToString { nameOf(it) }, color = Color.White.copy(alpha = 0.85f), style = MaterialTheme.typography.bodySmall)
        }
        Text(
            listOfNotNull(
                stringResource(if (interview.paid) Res.string.interview_paid_label else Res.string.interview_unpaid_label),
                stringResource(Res.string.interview_status_cancelled).takeIf { interview.isCancelled },
                stringResource(Res.string.interview_candidate_removed).takeIf { interview.candidateName == null }
            ).joinToString(" · "),
            color = MaterialTheme.colorScheme.secondary, style = MaterialTheme.typography.labelMedium
        )
        if (canEdit && !interview.isCancelled) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(Modifier.testTag(ApplicantsTags.moveInterview(interview.id))) {
                    EvoSecondaryButton(DialogAction(stringResource(Res.string.interview_move), onMove, icon = Icons.Default.Event), quiet = true)
                }
                Box(Modifier.testTag(ApplicantsTags.cancelInterview(interview.id))) {
                    EvoSecondaryButton(
                        DialogAction(stringResource(Res.string.interview_cancel), onCancel, destructive = true, icon = Icons.Default.EventBusy),
                        quiet = true
                    )
                }
            }
        }
    }
}

/** SH-210: "Reject?" with the rejection e-mail offered when the applicant gave an address. */
@Composable
private fun RejectDialog(application: JobApplication, offerMail: Boolean, onConfirm: (sendMail: Boolean) -> Unit, onDismiss: () -> Unit) {
    var sendMail by remember(application.id) { mutableStateOf(offerMail && application.email != null && application.rejectionMailAt == null) }
    EvoDialog(
        title = stringResource(Res.string.applicant_reject_title, application.name),
        icon = Icons.Default.Block,
        onDismiss = onDismiss,
        destructive = true,
        width = DialogWidth.Compact,
        // Without an address the post's offer still goes through: the use case answers NO_EMAIL and nothing is sent.
        confirm = DialogAction(
            stringResource(Res.string.applicant_reject),
            { onConfirm(if (application.email == null) offerMail else sendMail) },
            destructive = true
        )
    ) {
        Text(stringResource(Res.string.applicant_reject_text), color = Color.White)
        val email = application.email
        when {
            email == null -> Text(stringResource(Res.string.applicant_reject_no_email), color = Color.White.copy(alpha = 0.85f))
            application.rejectionMailAt != null -> Text(stringResource(Res.string.applicant_reject_already_sent), color = Color.White.copy(alpha = 0.85f))
            else -> EvoCheckboxRow(
                checked = sendMail, onCheckedChange = { sendMail = it },
                label = stringResource(Res.string.applicant_reject_send_mail, email),
                modifier = Modifier.testTag(ApplicantsTags.REJECT_SEND_MAIL)
            )
        }
    }
}

/**
 * SH-210: scheduling (or moving [interview]): the day, the start, the length, the place and/or an
 * online link, a note, who takes part (the team), paid or not, and the candidate's invitation.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun InterviewDialog(
    application: JobApplication,
    interview: Interview?,
    team: List<User>,
    problem: InvalidInterviewException.Problem?,
    saving: Boolean,
    onDismiss: () -> Unit,
    onSave: (InterviewRequest) -> Unit
) {
    val key = interview?.id ?: application.id
    var date by remember(key) { mutableStateOf(interview?.date.orEmpty()) }
    var time by remember(key) { mutableStateOf(interview?.startTime.orEmpty()) }
    var minutes by remember(key) { mutableStateOf(interview?.durationMinutes ?: 30) }
    var place by remember(key) { mutableStateOf(interview?.location.orEmpty()) }
    var link by remember(key) { mutableStateOf(interview?.onlineUrl.orEmpty()) }
    var note by remember(key) { mutableStateOf(interview?.note.orEmpty()) }
    var participants by remember(key) { mutableStateOf(interview?.participantIds.orEmpty()) }
    var paid by remember(key) { mutableStateOf(interview?.paid ?: false) }
    var send by remember(key) { mutableStateOf(application.email != null) }
    val errorText = problem?.let { stringResource(interviewProblemText(it)) }
    val fieldProblems = setOf(
        InvalidInterviewException.Problem.TIME_INVALID, InvalidInterviewException.Problem.PLACE_REQUIRED,
        InvalidInterviewException.Problem.LINK_INVALID
    )
    EvoDialog(
        title = if (interview == null) stringResource(Res.string.interview_dialog_title, application.name)
        else stringResource(Res.string.interview_reschedule_title),
        icon = Icons.Default.Event,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(if (interview == null) Res.string.interview_save else Res.string.interview_save_move),
            {
                onSave(
                    InterviewRequest(
                        postId = application.postId, applicationId = application.id, interviewId = interview?.id,
                        startsAt = "${date}T${time.padStart(5, '0')}", durationMinutes = minutes,
                        location = place, onlineUrl = link, note = note, participantIds = participants,
                        paid = paid, sendInvitation = send && application.email != null
                    )
                )
            },
            loading = saving
        )
    ) {
        EvoDateField(
            value = date, onValueChange = { date = it }, label = stringResource(Res.string.interview_date),
            missingYear = MissingYear.Upcoming, modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_DATE),
            error = errorText.takeIf { problem == InvalidInterviewException.Problem.TIME_INVALID }
        )
        EvoTimeField(
            value = time, onValueChange = { time = it }, label = stringResource(Res.string.interview_time),
            placeholder = "10:30", modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_TIME)
        )
        Text(stringResource(Res.string.interview_time_hint), color = Color.White.copy(alpha = 0.8f), style = MaterialTheme.typography.bodySmall)
        DialogSectionLabel(stringResource(Res.string.interview_length))
        val colors = FilterChipDefaults.filterChipColors(
            selectedContainerColor = MaterialTheme.colorScheme.secondary, selectedLabelColor = DeepNavy, labelColor = Color.White
        )
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            (INTERVIEW_LENGTHS + listOfNotNull(minutes.takeIf { it !in INTERVIEW_LENGTHS })).forEach { option ->
                FilterChip(
                    selected = minutes == option, onClick = { minutes = option }, colors = colors,
                    modifier = Modifier.handCursor().testTag(ApplicantsTags.length(option)),
                    label = { Text(pluralStringResource(Res.plurals.interview_minutes, option, option)) }
                )
            }
        }
        EvoTextField(
            value = place, onValueChange = { place = it.take(Interview.MAX_LOCATION) }, label = stringResource(Res.string.interview_place),
            supportingText = stringResource(Res.string.interview_place_hint), modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_PLACE),
            error = errorText.takeIf { problem == InvalidInterviewException.Problem.PLACE_REQUIRED }
        )
        EvoTextField(
            value = link, onValueChange = { link = it.take(Interview.MAX_URL) }, label = stringResource(Res.string.interview_online_link),
            keyboardType = KeyboardType.Uri, modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_LINK),
            error = errorText.takeIf { problem == InvalidInterviewException.Problem.LINK_INVALID }
        )
        EvoTextField(
            value = note, onValueChange = { note = it.take(Interview.MAX_NOTE) }, label = stringResource(Res.string.interview_note),
            singleLine = false, minLines = 2, modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_NOTE)
        )
        DialogSectionLabel(stringResource(Res.string.interview_participants))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            team.forEach { person ->
                FilterChip(
                    selected = person.uid in participants, colors = colors,
                    onClick = { participants = if (person.uid in participants) participants - person.uid else participants + person.uid },
                    modifier = Modifier.handCursor().testTag(ApplicantsTags.participant(person.uid)),
                    label = { Text(person.displayName) }
                )
            }
        }
        EvoSwitchRow(
            checked = paid, onCheckedChange = { paid = it }, label = stringResource(Res.string.interview_paid),
            supporting = stringResource(if (paid) Res.string.interview_paid_hint else Res.string.interview_unpaid_hint),
            modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_PAID)
        )
        val email = application.email
        if (email == null) {
            Text(stringResource(Res.string.interview_no_email), color = Color.White.copy(alpha = 0.85f))
        } else {
            EvoCheckboxRow(
                checked = send, onCheckedChange = { send = it }, label = stringResource(Res.string.interview_send, email),
                modifier = Modifier.testTag(ApplicantsTags.INTERVIEW_SEND)
            )
        }
        if (errorText != null && problem !in fieldProblems) Text(errorText, color = MaterialTheme.colorScheme.error)
    }
}
